import { produce } from 'immer';
import { ScopedAsyncType } from './scoped-type';
import { asyncAction } from './async-action';
import { getNProtectantForGrower } from '../../lib/api';

const initialState = {
  isLoading: false,
};

const SLICE = 'nProtectant';
const asyncType = ScopedAsyncType(SLICE);

const LOAD_NPROTECTANT_FOR_GROWER = asyncType('LOAD_NPROTECTANT_FOR_GROWER');

export const selectors = {
  fields: (state) => state[SLICE].fields,
  isLoading: (state) => state[SLICE].isLoading,
};

export const actions = {
  loadNProtectantForGrower,
};

function loadNProtectantForGrower(growerId) {
  return asyncAction(LOAD_NPROTECTANT_FOR_GROWER, () =>
    getNProtectantForGrower(growerId),
  );
}

const reducerHandlers = {
  [LOAD_NPROTECTANT_FOR_GROWER.start]: (state) => {
    state.fields = [];
    state.isLoading = true;
  },
  [LOAD_NPROTECTANT_FOR_GROWER.complete]: (state, payload) => {
    state.fields = payload;
    state.isLoading = false;
  },
  [LOAD_NPROTECTANT_FOR_GROWER.failure]: (state) => {
    state.fields = [];
    state.isLoading = false;
  },
};

export const reducers = {
  [SLICE]: (state = initialState, { type, payload } = {}) => {
    if (!reducerHandlers[type]) return state;
    return produce(state, (draft) => reducerHandlers[type](draft, payload));
  },
};
